import { render, staticRenderFns } from "./OccupationalAccident.vue?vue&type=template&id=3ea1d79a&"
import script from "./OccupationalAccident.vue?vue&type=script&lang=js&"
export * from "./OccupationalAccident.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports